var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',[_vm._v("You have a "+_vm._s(_vm.user.account.toLowerCase())+" account")])])
}
var staticRenderFns = []

export { render, staticRenderFns }